export default __webpack_public_path__ + "static/rollo-feb810fecbb3bff17473094df9170651.png";